var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useGetCustomizeAdminThemesQuery, useGetFileToDownloadQuery, useSaveAdminThemesCustomizeMutation, } from "@/store/api";
import toast from "react-hot-toast";
import { LoaderImage } from "@/utils/loader";
import { useNavigate } from "react-router";
/**
 *
 * <b>Page d'administration permettant aux administrateurs de personnaliser les thèmes : </b> couleurs, police,
 * opacité, image, bordure, padding et margin.
 */
export function Backgroundimgsettings() {
    var _this = this;
    var t = useTranslation([
        "common",
        "Administration",
        "Calendar",
        "ModuleBuilder",
        "Emails",
    ]).t;
    var navigate = useNavigate();
    var _a = useState({}), configs = _a[0], setConfigs = _a[1];
    var _b = useState({ image: "", file: "", type: "" }), image = _b[0], setImage = _b[1];
    var _c = useGetCustomizeAdminThemesQuery({}), configTheme = _c.data, isLoading = _c.isLoading, refetch = _c.refetch;
    var _d = useState(""), fileDataConfig = _d[0], setFileDataConfig = _d[1];
    useEffect(function () {
        if (configTheme) {
            if (configTheme === null || configTheme === void 0 ? void 0 : configTheme.data) {
                setConfigs(configTheme === null || configTheme === void 0 ? void 0 : configTheme.data);
            }
            if (configTheme === null || configTheme === void 0 ? void 0 : configTheme.data) {
                setImage({
                    image: configTheme.data.background_image.image,
                    file: configTheme.data.background_image.file,
                    type: configTheme.data.background_image.type,
                });
            }
        }
    }, [configTheme]);
    var _e = useState(false), isLoad = _e[0], setLoad = _e[1];
    var _f = useSaveAdminThemesCustomizeMutation(), saveThemeConfig = _f[0], _g = _f[1];
    var _h = useGetFileToDownloadQuery({
        params: {
            id: "bgImage",
            type: "Administration",
            isTempFile: false,
            tempName: image === null || image === void 0 ? void 0 : image.file,
            isRecordFile: false,
        },
    }), file = _h.data, error = _h.error;
    useEffect(function () {
        var fetchData = function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                try {
                    if (error) {
                        throw new Error("error fetching file");
                    }
                    if (file && file.data && file.data.output) {
                        setFileDataConfig(file.data.output);
                    }
                    else {
                        throw new Error("Output URL not found!");
                    }
                }
                catch (error) {
                    console.log("Error:", error);
                }
                return [2 /*return*/];
            });
        }); };
        fetchData();
    }, [file, error]);
    var saveConfigs = function () { return __awaiter(_this, void 0, void 0, function () {
        var updatedConfigs, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, 4, 5]);
                    setLoad(true);
                    updatedConfigs = __assign(__assign({}, configs), { background_image: __assign(__assign({}, configs === null || configs === void 0 ? void 0 : configs.background_image), { image: image.image, file: image.file, type: image.type }) });
                    setConfigs(updatedConfigs);
                    return [4 /*yield*/, saveThemeConfig({
                            body: updatedConfigs,
                        }).unwrap()];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, refetch()];
                case 2:
                    _a.sent();
                    configs &&
                        localStorage.setItem("theme_color", JSON.stringify({
                            background_image: image,
                            baseImage: (image === null || image === void 0 ? void 0 : image.type) === "image" ? fileDataConfig : image.file,
                        }));
                    return [3 /*break*/, 5];
                case 3:
                    err_1 = _a.sent();
                    toast.error("Erreur lors de la sauvegarde ".concat(err_1));
                    return [3 /*break*/, 5];
                case 4:
                    setLoad(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleURLChange = function (event) {
        var url = event.target.value;
        setImage({
            image: url,
            file: url,
            type: "url",
        });
        //setFileData({ fileName: "", base64Content: "" });
    };
    //https://www.w3schools.com/w3images/fjords.jpg
    return (_jsxs("div", __assign({ className: "configurator bg-[var(--colors-bg-default)] text-[--colors-label] p-2 space-y-6 m-2 rounded-md", style: { overflowY: "auto" } }, { children: [isLoad && _jsx(LoaderImage, {}), _jsx("div", __assign({ className: "columns" }, { children: _jsxs("div", __assign({ className: "column" }, { children: [_jsx("h1", __assign({ className: "title is-4" }, { children: t("LBL_LOGIN_BACKGROUND_IMG", { ns: "Administration" }) })), _jsxs("div", __assign({ className: "flex gap-2" }, { children: [_jsx("button", __assign({ className: "button primary", onClick: saveConfigs }, { children: t("app.LBL_SAVE_BUTTON_LABEL", { ns: "common" }) })), _jsx("button", __assign({ className: "button secondary", onClick: function () { return navigate(-1); } }, { children: t("app.LBL_CANCEL_BUTTON_LABEL", { ns: "common" }) }))] })), _jsx("div", __assign({ className: "card mt-4" }, { children: _jsx("div", __assign({ className: "card-content bg-[var(--colors-body-bg)]" }, { children: _jsx("div", __assign({ className: "content" }, { children: _jsxs("div", __assign({ className: "columns" }, { children: [_jsx("div", __assign({ className: "column" }, { children: _jsx("label", __assign({ className: "label font-medium" }, { children: t("LBL_BACKGROUND_IMAGE", { ns: "Administration" }) })) })), _jsx("div", __assign({ className: "column w-full" }, { children: _jsx("textarea", { value: image.type === "url" ? image.image : "", onChange: handleURLChange, placeholder: t("app.PLH_ENTER_IMAGE_URL", { ns: "common" }) ||
                                                        "Enter image URL", className: "border rounded dark:text-black px-2 py-1 w-full min-h-[150px]" }) }))] })) })) })) }))] })) }))] })));
}
